<div [formGroup]="form">
  <div class="flex items-center" mat-dialog-title>
    <div class="mr-3">
      <ic-icon [icon]="icWarning" class="text-amber-500" size="24px"></ic-icon>
    </div>
    <h2 class="headline m-0 pr-6 flex-auto">Contact référencé comme acteur achat</h2>
    <button class="text-secondary" mat-dialog-close type="button" mat-icon-button>
      <ic-icon [icon]="icClose"></ic-icon>
    </button>
  </div>

  <mat-dialog-content>
    <p class="mb-4">
      Le contact
      <strong>{{ contactName }}</strong>
      est référencé comme acteur achat. Sa suppression aura les impacts suivants :
    </p>

    <!-- Affichage informatif des impacts -->
    <div class="bg-orange-50 border border-orange-200 rounded-lg p-4 mb-6">
      <div *ngFor="let impact of data.dependencies.data" class="mb-2">
        <strong>{{ impact.name }} :</strong>
        <span>{{ impact.dependencies.join(', ') }}</span>
      </div>
    </div>

    <p class="mb-3">Comment souhaitez-vous traiter ces affectations ?</p>

    <mat-radio-group formControlName="choice" class="flex flex-col gap-2">
      <mat-radio-button value="replace">Remplacer le contact par un autre acteur achat</mat-radio-button>
      <mat-radio-button value="remove">Retirer les affectations de ce contact</mat-radio-button>
    </mat-radio-group>

    <div *ngIf="form.value.choice === 'replace'" class="mt-4">
      <p class="text-secondary text-sm mb-2" *ngIf="requiredRoleLabels">
        Le remplaçant doit couvrir : {{ requiredRoleLabels }}
      </p>
      <base-form-input
        label="Contact de remplacement"
        controlName="contact"
        type="autocomplete"
        [items$]="contacts$"
        displayProperty="fullName"
        (autocompleteChange)="autocompleteContacts($event)"
      ></base-form-input>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button type="button" (click)="dialogRef.close(false)">ANNULER</button>
    <button mat-raised-button color="primary" type="button" [disabled]="loading" (click)="confirm()">CONFIRMER</button>
  </mat-dialog-actions>
</div>
